const years = Array.from(document.querySelectorAll("[data-year-id]"));
const yearItems = Array.from(document.querySelectorAll("[data-item-id]"));

if (years && years.length > 0) {
  yearItems[0].classList.add("history__item--active");
  years[0].classList.add("history__timeline-item--active");

  let activeItem = yearItems[0];

  const removeactiveYear = async () => {
    yearItems.forEach((year) => {
      year.classList.remove("history__item--active");
    });
    years.forEach((year) => {
      year.classList.remove("history__timeline-item--active");
    });
  };

  const setActiveYear = (yearNavEntry) => {
    activeItem = yearItems.find((item) => {
      return item.dataset.itemId === yearNavEntry.dataset.yearId;
    });

    if (activeItem) {
      activeItem.classList.toggle("history__item--active");
      yearNavEntry.classList.toggle("history__timeline-item--active");
      // const scrollTo = document.getElementById("history__timeline")?.offsetTop;
      // window.scrollTo({
      //   top: scrollTo,
      //   behavior: "smooth",
      // });
    }
  };

  //Set first Items active

  years.forEach((yearNavEntry) => {
    yearNavEntry.addEventListener("click", async () => {
      await removeactiveYear();
      setActiveYear(yearNavEntry);
    });
  });

  const historyNext = document.querySelector("[data-history-next]");

  historyNext?.addEventListener("click", async () => {
    const nextIndex = yearItems.indexOf(activeItem) + 1;
    const nextItem = years[nextIndex];

    if (nextItem) {
      await removeactiveYear();
      setActiveYear(nextItem);
    } else {
      return;
    }
  });
  const historyPrev = document.querySelector("[data-history-prev]");

  historyPrev?.addEventListener("click", async () => {
    const prevIndex = yearItems.indexOf(activeItem) - 1;
    const prevItem = years[prevIndex];

    if (prevItem) {
      await removeactiveYear();
      setActiveYear(prevItem);
    } else {
      return;
    }
  });
}
